import React from 'react';
import {
  BrowserRouter as Router,
  Route, Link, Redirect, withRouter
} from 'react-router-dom';
import logo from "../../assets/imgs/zing_white_logo.png";

const Header = () => {
  return (
    <nav className="navbar navbar-expand-lg mx-auto fixed-top navbar-dark bg-dark">
      <div className="container">
        <a className="navbar-brand" href="/">
          <img src={logo} className="img-fluid logo"/>
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <a className="nav-link" href="/">Home <span
                className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#trackingSection">Tracking</a>
            </li>
          </ul>

          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/signin" href="#">
                <button className={'btn btn-link btn-sm'}>
                  SIGN IN
                </button>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/signup" href="#">
                <button className={'btn btn-secondary btn-sm'}>
                  SIGN UP
                </button>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
